import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { CountryInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class NormativeCountryApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(): Observable<Transaction<CountryInterface[]>> {
        return this.transactionRequest.wrap(
            this.apiClient.getNormativeCountries().pipe(
                map((countries) =>
                    countries.sort((c1: CountryInterface, c2: CountryInterface) => {
                        if (c1.name > c2.name) {
                            return 1;
                        } else if (c1.name < c2.name) {
                            return -1;
                        }

                        return 0;
                    })
                )
            )
        );
    }
}
